module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "who-gathers-the-edge-of-truths"
    }
  }, [_c('h1', [_vm._v("3. Who Gathers the Edge "), _c('br'), _vm._v("of Truths")]), _vm._v(" "), _c('p', [_vm._v("Who collects death or truths?—Yamadut?"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")]), _vm._v(" Or Hades? He is just driving us into the sea of eternal recurrence"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("2")]), _vm._v("—death—or you might raise your concern about having the convenience of truths. They are just divine and going to snatch our afternoon wine-reading.")]), _vm._v(" "), _c('p', [_vm._v("Truths carry nothing. Greek gods taught me what beauty is. Greek flesh taught me what art is. Greek philosophy taught me how humans should think. But I have never learned to be loved alone. I have desired to get touched by truth. There you are.")]), _vm._v(" "), _c('p', [_vm._v("There she is, there Salome"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn3",
      "id": "fnref3"
    }
  }, [_vm._v("3")]), _vm._v(". You are a woman—the truth, which humanity never learned. You are the art. You are the desire. You are those far-reached death and divine! Thou art truth! How could someone think of death and divine at once, together? These are exactly the contradictions of philosophers about the ‘truth’ and ‘dare’! Do you not think they are darting ‘dare’ in vain?")]), _vm._v(" "), _c('p', [_vm._v("“As truth is not easy to understand,” Vedas says.")]), _vm._v(" "), _c('p', [_vm._v("Satya"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn4",
      "id": "fnref4"
    }
  }, [_vm._v("4")]), _vm._v(" is a virtue. Humans always, from the beginning, try to grasp the truth, sanity, and persistence of their races—first, they invented the language full of deciding and vengeance and later the ‘ruth’, they are still trying to reach their destination, virtues. I am describing to you the truth and conscience in simple words. Philosophy had always been intricate to tell you this instinct. Who gathers truths as Nimrod gathers to pray? Are they aware of it? Truth is dying at all. How much truth can you endeavour?")]), _vm._v(" "), _c('p', [_vm._v("Society is a prison—if a man wants to live and discover the foundation of the truths as well as its farthest edge—he should abandon his abode"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn5",
      "id": "fnref5"
    }
  }, [_vm._v("5")]), _vm._v(". When I walk on the street and see the clouds running at a slow tempo, I feel bad about losing my youth—you will never be a child again. If you sneak, silently, into your skin; you will find no susceptible pleasure, look outward—your soul has been freed long ago. Truth is a mere mirage, and yet many artists and philosophers tried to hold it like an Olympian torch, but they never knew it had been blown away by their breath. You cannot control your thoughts; evil thoughts, mostly, unless you give yourself solace with immanent blows of humiliation to the opponent. You do it in your mind or heart because you are empty of courage. And you possess the bow of distrust and the arrow of soul terrorising ‘cry’—it deteriorates your reverence towards everyone. You are doomed either way! Your truth is doomed either way. Not even the Sanatan Dharma"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn6",
      "id": "fnref6"
    }
  }, [_vm._v("6")]), _vm._v(" gives you the absolute truth instead it provokes the ‘Way of life’. While they were chanting Isavasyam idam sarvam"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn7",
      "id": "fnref7"
    }
  }, [_vm._v("7")]), _vm._v(", how they did not realise that they were encapsulated with the non-truth. The truth has nuanced ‘threads of faith’; the concept has been percolated throughout every ‘religion’ and ‘faith’ hitherto. Most of the intellectual men are searching the ‘oneness’ sans thinking of existence. How could I not be blind, seeing those jugglers of truth? I laughed until I fell and got up not to laugh again at those self-styled renegades! Truths were never there! And never will; it can be superimposed. I am not entirely avoiding the truths but I am concerned that we took a wrong path to reach the truth. We can, verily, see the ‘blurry’ above our own arbitrary ‘clear’ un-truths. We have this beautiful way to reach the truth or Bramha—Adhyarop"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn8",
      "id": "fnref8"
    }
  }, [_vm._v("8")]), _vm._v(" Apawad"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn9",
      "id": "fnref9"
    }
  }, [_vm._v("9")]), _vm._v(". Inasmuch, I have no sentience to ultimate reality. It is hard to digest without knowing ‘non-knowledge’, and it is impossible living with sacrosanct. Let me be evil! Let me be unknowable ‘"), _c('strong', [_vm._v("knowledge")]), _vm._v("’.")]), _vm._v(" "), _c('p', [_vm._v("I see symptoms everywhere. My mind has a symptom of seeing "), _c('em', [_vm._v("Abyakta")]), _vm._v("; it is the worst judgement but not a false syndrome. It sucks your energy from your unconscious mind and leaves you in the torrent to search for accurate ripples, which, I think is not possible. The more I conceive the Abyakta, the more I push myself to pain. I could not bear the inexorable truth and started shaking and breathing out loud. The sigh’s extremities are inexplicable. All veins start to push blood into your skull and give you melancholy and unbearable torments. Abyakta is not a poison, yet you need to endure and strangulate hyoid bone of yourself like Nilkhantha Shiva – on of the triad of Hindu mythology."), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn10",
      "id": "fnref10"
    }
  }, [_vm._v("10")]), _vm._v("had to hold "), _c('em', [_vm._v("Halahal")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn11",
      "id": "fnref11"
    }
  }, [_vm._v("11")]), _vm._v(". Why am I so inclined to know the truths? I tell you there are myriad ways of learning and understanding the truth, but Abyakta is the sole psychology to acknowledge the entire foundation of justifiable human knowledge. Humans have forgotten to make the bond between historical ailments and the mind. Our hereditary mind is filled with anguish and affliction of an unquenchable thirst for knowing ultimate knowledge. Knowledge is a prediction of the erring; Galti"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn12",
      "id": "fnref12"
    }
  }, [_vm._v("12")]), _vm._v(". We are not allowed to break the doors of heaven (or hell).")]), _vm._v(" "), _c('p', [_vm._v("The philosopher is not seeking the truth, but rather a transformation of the world into man Nietzsche believes. And this transformation occurs when the mind aligns with Abyakta. Man can see everything, even the unseen. His mind is always awake, from the beginning of the universe, never sleeping, like ants. This ‘susceptible organ’ ponders genetics to genetics, asking why? What are they looking for? Do not proclaim the knowledge of awakening!")]), _vm._v(" "), _c('p', [_vm._v("How Schopenhauer had revered Upanishad and the knowledge of it. He says, “In the whole world there is no study so beneficial and so elevating as that of the Upanishads…It has been the solace of my life; and it will be the solace of my death. They are the product of the highest wisdom.”")]), _vm._v(" "), _c('p', [_vm._v("The more I understand the non-smiling charming face of Schopenhauer the more I tend to merge into Upanishad. We once had gone through infancy, taken steps of Vedas"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn13",
      "id": "fnref13"
    }
  }, [_vm._v("13")]), _vm._v(" and prostrated to Upanishadik Mahāvākyas"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn14",
      "id": "fnref14"
    }
  }, [_vm._v("14")]), _vm._v(" until we found our way back to mundane life. I urge you to come back from those ‘ways’ and give reason to your mind—find the truth never told before. We lost our way. We lost humanitarian beliefs—the drapes between historical ‘way’ and ‘human’ needs to be pulled up and let the light soak up the ‘redness’ of our error. Humans have long broiled between Sat and Asat"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn15",
      "id": "fnref15"
    }
  }, [_vm._v("15")]), _vm._v("; in like manner, our journey is simple, conquer the truth and make human life liveable.")]), _vm._v(" "), _c('p', [_vm._v("I was gathering the truths of human life but the knock on the door distracted me. I turned my head to the door. She was standing there—the girl from the café. Her eyes were full of fire—luminously staring at me. I remembered the "), _c('em', [_vm._v("Inferno")]), _vm._v("—where it reads—")]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("“When I had turned my eyes upon the faces")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Of some, on whom the dolorous fire is falling,")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Not one of them I knew; but I perceived.”")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("I never had the chance to investigate someone’s eyes so closely, or maybe I never wanted to. I had always been afraid of people’s gazes. The world has a million dimensions. If you see it from the priest’s eyes, you will see faith everywhere. If you see it from the eyes of the poor, you will see riches everywhere. If you see it from the eyes of the rich, you will see damnation everywhere. What am I seeing? From the eyes of mine? The world is empty. I don’t see anyone. I am all alone. Fucked up.")]), _vm._v(" "), _c('p', [_vm._v("Terrified. Busted. And then she was there, standing, waiting to be called in. I apologised for my inconvenience and called her in. She came and sat on my bed. Her diaphanous dress revealed every inch of her magnificence, indulgence, and freedom. I, on the other hand, looked cold, ugly, and a phantasmagoria of reluctance. We should chase Mambrino’s Helmet to protect our unchastised reason, it will rid us of our unhappy, unfulfilled, and ‘a bit on the side’ kind of life. Immediately, I saw her as Mambrino’s Helmet, or you could say Boethius’ ‘Consolation of Philosophy’—edging herself to my unoccupied belief. Boethius wrote "), _c('em', [_vm._v("The Consolation of Philosophy")]), _vm._v(" while in prison at Pavia waiting for his execution. At the same time, I think of her—the ‘Idea of the Good’—as the ascent to save my solitude.")]), _vm._v(" "), _c('p', [_vm._v("Involuntarily, my hands were reaching out to her and passages from Boethius’ work rushed through my head; it read:")]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("“It was difficult to be sure of her height, for sometimes she was of average human size, while at other times she seemed to touch the very sky with the top of her head, and when she lifted herself even higher, she pierced it and was lost to human sight.”")])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("I was brought back to reality when our lips met. We were kissing. I was unexpectedly kissing philosophy. I had no fortune earlier, so I had no fear of abandonment like Boethius, but when she came into reality, I suddenly raised my arm and said, “Come, my dear Grace, let us together reduce my grief and sorrow of misfortune.”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_c('sup', [_vm._v("1 ")]), _vm._v("Lord of death as Hindu mythology."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn2"
    }
  }, [_c('p', [_c('sup', [_vm._v("2 ")]), _vm._v("Nietzsche’s concept about eternal recurrence."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref2"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn3"
    }
  }, [_c('p', [_c('sup', [_vm._v("3 ")]), _vm._v("Nietzsche proposed her and got rejected."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref3"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn4"
    }
  }, [_c('p', [_c('sup', [_vm._v("4 ")]), _vm._v("Meaning is ‘truth’ in Sanskrit."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref4"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn5"
    }
  }, [_c('p', [_c('sup', [_vm._v("5 ")]), _vm._v("Influenced from "), _c('em', [_vm._v("Nature")]), _vm._v(" by Ralph W Emerson."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref5"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn6"
    }
  }, [_c('p', [_c('sup', [_vm._v("6 ")]), _vm._v("the eternal way of life in Sanskrit."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref6"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn7"
    }
  }, [_c('p', [_c('sup', [_vm._v("7 ")]), _vm._v("All this is enveloped by God in Sanskrit."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref7"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn8"
    }
  }, [_c('p', [_c('sup', [_vm._v("8 ")]), _vm._v("Superimposition"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref8"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn9"
    }
  }, [_c('p', [_c('sup', [_vm._v("9 ")]), _vm._v("superimposition is sublated through the Apavada."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref9"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn10"
    }
  }, [_c('sup', [_vm._v("10 ")]), _vm._v("Shiva – on of the triad of Hindu mythology.")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn11"
    }
  }, [_c('p', [_c('sup', [_vm._v("11 ")]), _vm._v("Mythological poison described in Purans."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref11"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn12"
    }
  }, [_c('p', [_c('sup', [_vm._v("12 ")]), _vm._v("Error"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref12"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn13"
    }
  }, [_c('p', [_c('sup', [_vm._v("13 ")]), _vm._v("Four Hindu Sacred Scriptures."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref13"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn14"
    }
  }, [_c('p', [_c('sup', [_vm._v("14 ")]), _vm._v("The great saying of Upanishad."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref14"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn15"
    }
  }, [_c('p', [_c('sup', [_vm._v("15 ")]), _vm._v("Truth and non-truth"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref15"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a10bb7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 84
// module chunks = 0